module.exports = __webpack_public_path__ + "static/clicky-game-18777669530ab77d8ce615e89995d0c0.webp";